import { Component, computed } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-toast-container',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
})
export class ToastContainerComponent {
  constructor(private toast: ToastService) {}
  toasts = computed(() => this.toast.toasts());
  dismiss = (id: number) => this.toast.dismiss(id);
}
